import { JsonObject, JsonProperty } from "typescript-json-serializer";

@JsonObject()
export class NavigationConfiguration {

    // identifier
    @JsonProperty()
    declare id?: string;

    // for displaying
    @JsonProperty()
    declare label?: string;

    @JsonProperty()
    declare class?: string;

    // indicates the top-level items
    @JsonProperty()
    declare isTopLevel: boolean;

    @JsonProperty()
    items: NavigationItemConfiguration[] = [];

    constructor() {}
}

@JsonObject()
export class NavigationItemConfiguration {
    // identifier
    @JsonProperty()
    id?: string;

    @JsonProperty()
    declare title: string;

    @JsonProperty()
    visible?: boolean;

    @JsonProperty()
    href?: string;

    @JsonProperty()
    target?: string;

    @JsonProperty()
    class?: string;

    @JsonProperty()
    sub?: NavigationConfiguration;

    constructor() {}
}

